module.exports = __webpack_public_path__ + "tabletSlideAlt.jpg?7e3953b6dd0c2b5c9e1ebae16eea838a";